import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=4c58b2a1&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
import style0 from "./Auth.vue?vue&type=style&index=0&id=4c58b2a1&prod&scoped=true&lang=css"
import style1 from "./Auth.vue?vue&type=style&index=1&id=4c58b2a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c58b2a1",
  null
  
)

export default component.exports